export enum SourceEventsEnum {
  VerdictLetter = 'verdict_letter',
}
